
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import BASE_URL from "../../BASEURL";


export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please fill in all fields");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        toast.success(data.message || "Admin Login successful");
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("adminEmail", data.admin.email);
        navigate("/admin/dashboard");
      } else {
        toast.error(data.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("Admin login error:", error);
      toast.error("An error occurred during admin login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center relative bg-gradient-to-br from-amber-100 via-white to-amber-200 py-12 px-4 overflow-hidden">
      {/* Decorative background image */}
      <img
        src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=900&q=80"
        alt="background"
        className="absolute inset-0 w-full h-full object-cover opacity-30 pointer-events-none select-none z-0"
      />
      {/* Glassmorphism card */}
      <div className="relative z-10 w-full max-w-md bg-white/70 backdrop-blur-lg rounded-3xl shadow-2xl p-8 sm:p-12 border border-amber-200">
        <div className="flex flex-col items-center gap-2 mb-8">
          <img src="../image/logo/LOGO.png" alt="Logo" className="h-16 drop-shadow-lg rounded-full border-2 border-amber-200 bg-white" />
          <h2 className="text-4xl sm:text-5xl font-extrabold text-amber-900 font-serif tracking-tight drop-shadow">Admin Panel</h2>
          <span className="text-xs text-amber-700 font-semibold tracking-widest uppercase">Secure Access</span>
        </div>

        <form onSubmit={handleLogin} className="space-y-7">
          <div>
            <label className="block mb-1 font-semibold text-amber-900">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Your Admin Email"
              className="w-full border border-amber-300 rounded-xl px-4 py-3 focus:outline-none focus:border-amber-500 bg-amber-50 text-amber-900 placeholder-amber-400 transition text-base shadow-sm"
              autoComplete="username"
              required
            />
          </div>

          <div>
            <label className="block mb-1 font-semibold text-amber-900">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Your AAdmin Password"
                className="w-full border border-amber-300 rounded-xl px-4 py-3 pr-12 focus:outline-none focus:border-amber-500 bg-amber-50 text-amber-900 placeholder-amber-400 transition text-base shadow-sm"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-amber-400 hover:text-amber-700 focus:outline-none"
                tabIndex={-1}
                aria-label="Toggle password visibility"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 rounded-xl font-bold text-lg shadow-lg transition-all duration-200 font-serif tracking-wide 
              ${loading ? "bg-amber-300 text-white cursor-not-allowed" : "bg-amber-600 hover:bg-amber-700 text-white"}`}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path></svg>
                Logging in...
              </span>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </section>
  );
}
